import { render, staticRenderFns } from "./Filial.container.vue?vue&type=template&id=054360fd&"
import script from "./Filial.container.vue?vue&type=script&lang=ts&"
export * from "./Filial.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports